export {};

declare global {
  function isValidString (value: string): boolean;
  function isValidNumber (value: number): boolean;
  function isNullOrUndefined (value: any): boolean;
  function isValidArray (value: any []): boolean;
}

let _global: any;

if (typeof window !== 'undefined') { // Для браузерной среды
    _global = window;
} else if (typeof global !== 'undefined') { // Для среды Node.js
    _global = global;
} else {
    throw new Error('No global object found');
}

_global.isNullOrUndefined = function (value: any): boolean {
    if (typeof value === 'undefined' || value === null) {
        return true;
    } else {
        return false;
    }
};
_global.isValidString = function (value: string): boolean {
    if (typeof value === 'undefined' || value === null || value === '') {
        return false;
    } else {
        return true;
    }
};

_global.isValidNumber = function (value: number): boolean {
    if (typeof value === 'undefined' || value === null || isNaN(value)) {
        return false;
    } else {
        return true;
    }
};

_global.isValidArray = function (value: []): boolean {
    if (typeof value === 'undefined' || value === null || value.length === 0) {
        return false;
    } else {
        return true;
    }
};
